var map = {
	"./logo-agilimo.svg": "fe83",
	"./logo-icinga.svg": "de30",
	"./logo-lango.svg": "87d4",
	"./logo-loacker.svg": "c6cf",
	"./logo-volksbank.svg": "58b8",
	"./logo-wp.svg": "ed21d",
	"./logo-wuerth.svg": "dc79"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c47d";